import React, { useEffect } from 'react';
import { useUser } from '../../hooks/UserContext';
import { ROLE_LEVELS } from '../../hooks/useRole';

function redirectForUser(userData) {
  const level = ROLE_LEVELS[userData.role] ?? 99;
  if (level <= 20) return '/admin/dashboard'; // admin/super_user — sees everything
  if (level >= 99) return '/waiting'; // no role
  // Regular user — check which dimensions they have access to
  const hasProjects = Array.isArray(userData.projects) && userData.projects.length > 0;
  const hasIot = Array.isArray(userData.iotAccess) && userData.iotAccess.length > 0;
  if (hasProjects) return '/project/home';
  if (hasIot) return '/admin/dashboard';
  return '/waiting'; // user role but no grants yet
}

function GloginComponent() {
  const { login } = useUser();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: '644083780858-76r0grpthj4jvvhdbsr4ncaiep8qrntc.apps.googleusercontent.com',
        scope: 'profile email',
        callback: onSignIn,
      });
      window.google.accounts.id.renderButton(document.getElementById('glogin'), {});
    };
    document.body.appendChild(script);
  }, []);

  function onSignIn(googleUser) {
    fetch(`${window.location.origin}/auth?tkn=${googleUser.credential}`)
      .then((response) => {
        if (response.ok) return response.json();
        throw new Error('Failed to authenticate');
      })
      .then((data) => {
        localStorage.setItem('tkn', googleUser.credential);
        login(data.userData);
        const parsed = typeof data.userData === 'string' ? JSON.parse(data.userData) : data.userData;
        window.location.href = redirectForUser(parsed);
      })
      .catch((error) => {
        console.error('Authentication error:', error);
      });
  }

  return <div id="glogin" />;
}

export default GloginComponent;

